import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PublicLayout from "./components/PublicLayout";
import Home from "./pages/public/Home";
import Services from "./pages/public/Services";
import Specialist from "./pages/public/Specialist";
import Pricing from "./pages/public/Pricing";
import GetQuote from "./pages/public/GetQuote";
import Book from "./pages/public/Book";
import Commercial from "./pages/public/Commercial";
import About from "./pages/public/About";
import Careers from "./pages/public/Careers";
import Contact from "./pages/public/Contact";
import Legal from "./pages/public/Legal";
import { Login, Register, AuthCallback } from "./pages/auth/Auth";
import InviteAccept from "./pages/auth/InviteAccept";
import CustomerPortal from "./pages/portal/CustomerPortal";
import { PaymentSuccess, PaymentCancel } from "./pages/portal/PaymentReturn";
import CleanerPortal from "./pages/cleaner/CleanerPortal";
import AdminDashboard from "./pages/admin/AdminDashboard";

const STAFF = ["founder_ceo", "ops_manager", "admin", "supervisor"];

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]"><span className="diamond animate-pulse" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const dest = user.role === "customer" ? "/portal" : user.role === "cleaner" ? "/cleaner" : "/admin";
    return <Navigate to={dest} replace />;
  }
  return children;
}

const P = (C) => (
  <PublicLayout><C /></PublicLayout>
);

function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("bd_cookie")) setShow(true); }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bg-[#0a0a0a] border-t border-[#333] p-4 lg:pr-44">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-3 justify-between">
        <p className="text-[#cfcabf] text-xs">We use essential cookies to operate this site and optional cookies with your consent. See our Cookie Policy.</p>
        <div className="flex gap-2">
          <button data-testid="cookie-accept" onClick={() => { localStorage.setItem("bd_cookie", "all"); setShow(false); }} className="btn-gold px-4 py-2 rounded-sm text-xs">Accept</button>
          <button data-testid="cookie-essential" onClick={() => { localStorage.setItem("bd_cookie", "essential"); setShow(false); }} className="btn-outline-gold px-4 py-2 rounded-sm text-xs">Essential only</button>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors duration={3000} />
        <CookieConsent />
        <Routes>
          <Route path="/" element={P(Home)} />
          <Route path="/services" element={P(Services)} />
          <Route path="/specialist" element={P(Specialist)} />
          <Route path="/pricing" element={P(Pricing)} />
          <Route path="/quote" element={P(GetQuote)} />
          <Route path="/book" element={P(Book)} />
          <Route path="/commercial" element={P(Commercial)} />
          <Route path="/about" element={P(About)} />
          <Route path="/careers" element={P(Careers)} />
          <Route path="/contact" element={P(Contact)} />
          <Route path="/legal/:slug" element={P(Legal)} />
          <Route path="/login" element={<Login />} />
          <Route path="/staff-login" element={<Login />} />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route path="/portal" element={<Protected roles={["customer"]}><CustomerPortal /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/cleaner" element={<Protected roles={["cleaner"]}><CleanerPortal /></Protected>} />
          <Route path="/admin" element={<Protected roles={STAFF}><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
